// extracted by mini-css-extract-plugin
export var button = "sector-grid-module--button--e849d";
export var grid = "sector-grid-module--grid--c0938";
export var grid__column = "sector-grid-module--grid__column--03643";
export var grid__column__text = "sector-grid-module--grid__column__text--80888";